
const payRouter = [
    // 订单支付页面
    {
    	path: '/payOrder', 
    	name: 'payOrder', 
    	meta: { name: '支付订单'},
    	component: () => import('@/views/accessories/payOrder')
    },
    // 订单支付详情-收银台页面
    {
    	path: '/payDetail', 
    	name: 'payDetail', 
    	meta: { name: '支付订单'},
    	component: () => import('@/views/accessories/payDetail')
    },
]
export default payRouter


// WEBPACK FOOTER //
// ./src/router/modules/pay.js